import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Label, FormGroup, Col, Form, Input, Row} from 'reactstrap';
import FormWrapper from './../../../commonComponents/formWrapper/FormWrapper.container';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import {Utils} from './../../../../utils/utils';
import _ from 'lodash';
import './DefaultAliasManagement.css';
import Select from "../../../commonComponents/customSelect/CustomSelect.container";
import {ROLES} from "../../../../reducers/account/role";

const requiredSelectFields = ['countryCode'];

class DefaultAliasManagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            countryCode: "",
            exposePhone: false,
            exposeEmail: false,
            requiredFieldError: null
        };
    }

    componentDidMount() {
        this.props.onGetDefaultAlias();
    }

    componentWillUnmount() {
        this.props.onContinentSet("");
        this.props.onUnmount();
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.data) && nextProps.data !== this.props.data) {
            this.setState({
                firstName: nextProps.data.firstName,
                lastName: nextProps.data.lastName,
                phoneNumber: nextProps.data.phoneNumber || "",
                countryCode: nextProps.data.countryCode,
                exposePhone: nextProps.data.exposePhone,
                exposeEmail: nextProps.data.exposeEmail
            });
            this.props.setCurrentContinentByCountry(nextProps.data.countryCode);
        }
        if (nextProps.continentCode !== this.state.continentCode) {
            this.setState({continentCode: nextProps.continentCode});
        }
    }

    render() {
        return (
            <div className="change-default-alias-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'aliases.edit_success_message')}
                >
                    <Form onSubmit={this.onSubmit}>
                        <h5 className="text-center">{_.get(this.props.translation, 'aliases.edit_default_alias')}</h5>
                        {this.renderContent()}
                    </Form>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && _.isNil(this.props.data)) {
            return (
                <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
            )
        }

        return (
            <div>
                {this.renderAliasFormGroups()}
                {this.renderLocationFormGroups()}
                {this.renderCheckBoxes()}
                <div className="button-container">
                    <Button className="olive-green-btn" disabled={this.saveButtonDisabled()}
                            type="submit">{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </div>
        );
    };

    saveButtonDisabled = () => {
        if (_.isNil(this.props.data)) {
            return true;
        }

        let oldData = {
            ...this.props.data,
            phoneNumber: this.props.data.phoneNumber || ""
        };

        return _.every(oldData, (value, key) => this.state.hasOwnProperty(key) ? this.state[key] === value : true);
    };

    renderCheckBoxes = () => {
        if (this.props.role !== ROLES.APPLICANT) {
            return null;
        }

        return [
            <div className="alias-checkbox-container" key="expose-phone-container">
                <FormGroup key="expose-phone" className='alias-checkbox-group'>
                    <Row className='checkbox-container'>
                        <Label className='checkbox-label'>
                            <Input
                                type="checkbox"
                                checked={this.state.exposePhone}
                                onChange={this.handleChangeExpose("exposePhone")}
                            />
                            {_.get(this.props.translation, 'aliases.expose_phone_label')}
                        </Label>
                    </Row>
                </FormGroup>
            </div>,
            <div className="alias-checkbox-container" key="expose-email-container">
                <FormGroup key="expose-email" className='alias-checkbox-group'>
                    <Row className='checkbox-container'>
                        <Label className='checkbox-label'>
                            <Input
                                type="checkbox"
                                checked={this.state.exposeEmail}
                                onChange={this.handleChangeExpose("exposeEmail")}
                            />
                            {_.get(this.props.translation, 'aliases.expose_email_label')}
                        </Label>
                    </Row>
                </FormGroup>
            </div>
        ];
    };

    renderAliasFormGroups = () => {
        let paramsList = [
            {
                value: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                isRequired: true
            },
            {
                value: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                isRequired: true
            },
            {
                value: "phoneNumber",
                title: _.get(this.props.translation, sharedLabelsPath.phone_number_label)
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderLocationFormGroups = () => {
        let paramsList = [
            {
                value: "continentCode",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                onChange: this.handleChangeContinent,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                isDisabled: !this.props.continents,
                isRequired: true
            },
            {
                value: "countryCode",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                onChange: this.handleChangeCountry,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isDisabled: !this.props.countries,
                isRequired: true
            }
        ];

        return [..._.map(paramsList, this.getSelectFormGroup)];
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    getFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.title}
                           required={params.isRequired}
                           disabled={params.isDisabled}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeExpose = (fieldKey) => () => {
        this.setState({[fieldKey]: !this.state[fieldKey]});
    };

    handleChangeContinent = (selectedOption) => {
        this.props.onContinentSet(selectedOption.value);
        this.setState({countryCode: ""});
    };

    handleChangeCountry = (selectedOption) => {
        this.setState({countryCode: selectedOption.value});
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let data = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumber: (!_.isNil(this.state.phoneNumber) && this.state.phoneNumber !== "") ? this.state.phoneNumber : null,
            countryCode: this.state.countryCode,
            exposePhone: this.state.exposePhone,
            exposeEmail: this.state.exposeEmail
        };

        this.props.onChangeAlias(this.props.data.id, data);
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

DefaultAliasManagement.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    onContinentSet: PropTypes.func.isRequired,
    setCurrentContinentByCountry: PropTypes.func.isRequired,
    onChangeAlias: PropTypes.func,
    onUnmount: PropTypes.func.isRequired
};

export default DefaultAliasManagement;



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/defaultAliasManagement/DefaultAliasManagement.js